// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import { Building2, HandHeart, Banknote, Users } from 'lucide-react';

// const UniqueValueSection: React.FC = () => {
//   const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

//   const features = [
//     {
//       icon: <Building2 size={28} />,
//       title: "Independent Practice Community",
//       description: "We've built a collaborative community of independent practitioners rather than hiring therapists as employees. This ensures authentic, autonomous care."
//     },
//     {
//       icon: <Banknote size={28} />,
//       title: "Direct & Transparent Pricing",
//       description: "All proceeds go directly to your therapist, with charges set by them. No hidden fees or middleman markups - just fair, transparent pricing."
//     },
//     {
//       icon: <HandHeart size={28} />,
//       title: "Fair Compensation",
//       description: "We ensure therapists are compensated fairly while keeping therapy affordable. This sustainable model benefits both clients and practitioners."
//     },
//     {
//       icon: <Users size={28} />,
//       title: "Collaborative Care",
//       description: "Your healing journey is supported by multiple professionals working together, providing comprehensive care across different capacities."
//     }
//   ];

//   return (
//     <section className="relative py-24 overflow-hidden bg-gradient-to-br from-orange-50 via-white to-teal-50">
//       {/* Dynamic Background */}
//       <div className="absolute inset-0">
//         <motion.div
//           className="absolute inset-0"
//           animate={{
//             backgroundPosition: ['0% 0%', '100% 100%'],
//           }}
//           transition={{
//             duration: 20,
//             repeat: Infinity,
//             repeatType: "reverse",
//           }}
//           style={{
//             backgroundImage: `
//               radial-gradient(circle at 20% 20%, rgba(245, 158, 11, 0.07) 0%, transparent 40%),
//               radial-gradient(circle at 80% 80%, rgba(15, 118, 110, 0.07) 0%, transparent 40%)
//             `,
//           }}
//         />
//       </div>

//       <div className="max-w-7xl mx-auto px-4 relative">
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.6 }}
//           className="text-center mb-16"
//         >
//           <div className="inline-block">
//             <motion.div
//               className="text-3xl md:text-4xl font-bold text-teal-900 mb-6 relative"
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//             >
//               What Makes Us Different?
//               <motion.div
//                 className="absolute -bottom-2 left-0 right-0 h-1 bg-orange-400"
//                 initial={{ scaleX: 0 }}
//                 whileInView={{ scaleX: 1 }}
//                 viewport={{ once: true }}
//                 transition={{ duration: 0.8, delay: 0.2 }}
//               />
//             </motion.div>
//           </div>
//         </motion.div>

//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 relative mb-16">
//           {/* Image Column */}
//           <motion.div 
//             className="lg:col-span-1 relative rounded-2xl overflow-hidden h-full min-h-[300px] lg:min-h-[600px]"
//             initial={{ opacity: 0, x: -50 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6 }}
//           >
//             <img
//               src="/images/differentsection.jpeg"
//               alt="Our Therapy Community"
//               className="absolute inset-0 w-full h-full object-cover"
//             />
//             <div className="absolute inset-0 bg-gradient-to-t from-teal-900/60 via-transparent to-transparent" />
//             <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
//               <h3 className="text-2xl font-bold mb-2">Join Our Community</h3>
//               <p className="text-white/90">Experience therapy that prioritizes both client well-being and therapist autonomy.</p>
//             </div>
//           </motion.div>

//           {/* Features Grid */}
//           <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
//             {features.map((feature, index) => (
//               <motion.div
//                 key={feature.title}
//                 initial={{ opacity: 0, x: 50, y: 50 }}
//                 whileInView={{ opacity: 1, x: 0, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ duration: 0.6, delay: index * 0.1 }}
//                 onHoverStart={() => setHoveredIndex(index)}
//                 onHoverEnd={() => setHoveredIndex(null)}
//                 className="relative group"
//               >
//                 <div className="relative z-10 h-full">
//                   <motion.div
//                     className={`
//                       p-8 rounded-2xl h-full
//                       backdrop-blur-md border
//                       transition-colors duration-300
//                       ${hoveredIndex === index 
//                         ? 'bg-white shadow-lg border-orange-200' 
//                         : 'bg-white/80 border-teal-100'}
//                     `}
//                   >
//                     <div className="flex flex-col h-full">
//                       <div className="flex items-center space-x-4 mb-4">
//                         <motion.div
//                           className={`
//                             p-3 rounded-xl text-white
//                             ${hoveredIndex === index ? 'bg-orange-400' : 'bg-teal-700'}
//                             transition-colors duration-300
//                           `}
//                           whileHover={{ rotate: 360 }}
//                           transition={{ duration: 0.5 }}
//                         >
//                           {feature.icon}
//                         </motion.div>
//                         <h3 className="text-xl font-semibold text-teal-900">
//                           {feature.title}
//                         </h3>
//                       </div>
//                       <p className="text-gray-600 leading-relaxed">
//                         {feature.description}
//                       </p>
//                     </div>
//                   </motion.div>
//                 </div>

//                 {/* Decorative Elements */}
//                 <motion.div
//                   className="absolute -inset-0.5 bg-gradient-to-r from-orange-400 to-teal-400 rounded-2xl opacity-0 group-hover:opacity-10 transition-opacity duration-300"
//                   animate={{
//                     scale: hoveredIndex === index ? [1, 1.02, 1] : 1,
//                   }}
//                   transition={{ duration: 1, repeat: Infinity }}
//                 />
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default UniqueValueSection;

import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Building2, HandHeart, Banknote, Users, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const UniqueValueSection: React.FC = () => {
  const navigate = useNavigate();
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const features = [
    {
      icon: <Building2 size={28} />,
      title: "Independent Practice Community",
      description: "We've built a collaborative community of independent practitioners rather than hiring therapists as employees. This ensures authentic, autonomous care."
    },
    {
      icon: <Banknote size={28} />,
      title: "Direct & Transparent Pricing",
      description: "All proceeds go directly to your therapist, with charges set by them. No hidden fees or middleman markups - just fair, transparent pricing."
    },
    {
      icon: <HandHeart size={28} />,
      title: "Fair Compensation",
      description: "We ensure therapists are compensated fairly while keeping therapy affordable. This sustainable model benefits both clients and practitioners."
    },
    {
      icon: <Users size={28} />,
      title: "Collaborative Care",
      description: "Your healing journey is supported by multiple professionals working together, providing comprehensive care across different capacities."
    }
  ];

  return (
    <section className="relative py-24 overflow-hidden bg-gradient-to-br from-orange-50 via-white to-teal-50">
      {/* Dynamic Background */}
      <div className="absolute inset-0">
        <motion.div
          className="absolute inset-0"
          animate={{
            backgroundPosition: ['0% 0%', '100% 100%'],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          style={{
            backgroundImage: `
              radial-gradient(circle at 20% 20%, rgba(245, 158, 11, 0.07) 0%, transparent 40%),
              radial-gradient(circle at 80% 80%, rgba(15, 118, 110, 0.07) 0%, transparent 40%)
            `,
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-block">
            <motion.div
              className="text-3xl md:text-4xl font-bold text-teal-900 mb-6 relative"
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              What Makes Us Different?
              <motion.div
                className="absolute -bottom-2 left-0 right-0 h-1 bg-orange-400"
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.2 }}
              />
            </motion.div>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 relative mb-16">
          {/* Image Column */}
          <motion.div 
            className="lg:col-span-1 relative rounded-2xl overflow-hidden h-full min-h-[300px] lg:min-h-[600px]"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <img
              src="/images/differentsection.jpeg"
              alt="Our Therapy Community"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-teal-900/60 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
              <h3 className="text-2xl font-bold mb-2">Join Our Community</h3>
              <p className="text-white/90">Experience therapy that prioritizes both client well-being and therapist autonomy.</p>
            </div>
          </motion.div>

          {/* Features Grid */}
          <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
            {features.map((feature, index) => (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, x: 50, y: 50 }}
                whileInView={{ opacity: 1, x: 0, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                onHoverStart={() => setHoveredIndex(index)}
                onHoverEnd={() => setHoveredIndex(null)}
                className="relative group"
              >
                <div className="relative z-10 h-full">
                  <motion.div
                    className={`
                      p-8 rounded-2xl h-full
                      backdrop-blur-md border
                      transition-colors duration-300
                      ${hoveredIndex === index 
                        ? 'bg-white shadow-lg border-orange-200' 
                        : 'bg-white/80 border-teal-100'}
                    `}
                  >
                    <div className="flex flex-col h-full">
                      <div className="flex items-center space-x-4 mb-4">
                        <motion.div
                          className={`
                            p-3 rounded-xl text-white
                            ${hoveredIndex === index ? 'bg-orange-400' : 'bg-teal-700'}
                            transition-colors duration-300
                          `}
                          whileHover={{ rotate: 360 }}
                          transition={{ duration: 0.5 }}
                        >
                          {feature.icon}
                        </motion.div>
                        <h3 className="text-xl font-semibold text-teal-900">
                          {feature.title}
                        </h3>
                      </div>
                      <p className="text-gray-600 leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </motion.div>
                </div>

                {/* Decorative Elements */}
                <motion.div
                  className="absolute -inset-0.5 bg-gradient-to-r from-orange-400 to-teal-400 rounded-2xl opacity-0 group-hover:opacity-10 transition-opacity duration-300"
                  animate={{
                    scale: hoveredIndex === index ? [1, 1.02, 1] : 1,
                  }}
                  transition={{ duration: 1, repeat: Infinity }}
                />
              </motion.div>
            ))}
          </div>
        </div>

        {/* New Navigation Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex justify-center"
        >
          <motion.button
            onClick={() => navigate('/group-practice')}
            className="group flex items-center space-x-2 px-6 py-3 text-lg font-medium text-white bg-teal-700 rounded-xl hover:bg-teal-800 transition-colors duration-300
                     shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-transform duration-300
                     sm:text-base md:text-lg lg:text-xl"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <span>Explore Our Group Practice</span>
            <motion.div
              className="inline-block"
              initial={{ x: 0 }}
              whileHover={{ x: 5 }}
            >
              <ArrowRight className="w-5 h-5" />
            </motion.div>
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default UniqueValueSection;